var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCompany = function SvgCompany(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 17.5 14.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.2h-3.6v-.7c0-.8-.7-1.5-1.5-1.5H6.6c-.8 0-1.5.7-1.5 1.5v.7H1.5C.7 2.2 0 2.8 0 3.6v2.2c0 .8.7 1.5 1.5 1.5h5.8v-.4c0-.2.2-.4.4-.4h2.2c.2 0 .4.2.4.4v.4H16c.8 0 1.5-.7 1.5-1.5V3.6c0-.8-.7-1.4-1.5-1.4m-5.1 0H6.6v-.7H11zM17.3 7.7c-.1-.1-.3 0-.4 0q-.3.3-.9.3h-5.8v1.1c0 .2-.2.4-.4.4H7.7c-.2 0-.4-.2-.4-.4V8H1.5q-.6 0-.9-.3c-.2-.1-.4-.1-.5.1-.1.1-.1.1-.1.2v5.1c0 .8.7 1.5 1.5 1.5H16c.8 0 1.5-.7 1.5-1.5V8c0-.1-.1-.3-.2-.3",
    className: "company_svg__st0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCompany);
export default ForwardRef;